/**
 * Set Details state atoms
 *
 * State for the Set Details page including view mode and selected card.
 */
import { atom } from 'jotai';

// ============================================================================
// View Mode
// ============================================================================

export type SetViewMode = 'table' | 'grid' | 'summary';

/** Current view mode for set details page */
export const setViewModeAtom = atom<SetViewMode>('table');

// ============================================================================
// Selected Card
// ============================================================================

/** Currently selected card ID for details panel (null = panel closed) */
export const selectedSetCardAtom = atom<string | null>(null);
